import { useContext } from 'react';
import PropTypes from 'prop-types';

import UserContext from 'core/components/User';
import UnityIdContext from 'core/components/UnityId';

export default function withUser(Component) {
  function UserConsumer(props, context) {
    const { enableUnityId } = context.features;

    const unityIdUser = useContext(UnityIdContext);
    const ramblerIdUser = useContext(UserContext);

    if (enableUnityId) {
      return <Component user={unityIdUser} {...props}  />;
    }

    return <Component user={ramblerIdUser} {...props}  />;
  }

  UserConsumer.contextTypes = {
    features: PropTypes.shape({
      enableUnityId: PropTypes.bool,
    }),
  };

  return UserConsumer;
}
